import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/management/permessi.svg'
import _imports_2 from '@/assets/img/management/admins.svg'
import _imports_3 from '@/assets/img/management/moderators.svg'
import _imports_4 from '@/assets/img/management/trash_red.png'


const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { class: "listButtonContainer" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  style: {"width":"24px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue",
        localizedKey: "app_impostazioni{{type}}",
        text: "Impostazioni {{type}}",
        object: { 'type': _ctx.type }
      }, null, 8, ["object"]),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.permissions()))
      }, [
        _hoisted_6,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_permessi",
          text: "Permessi"
        })
      ]),
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.administrators()))
      }, [
        _hoisted_7,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_amministratori",
          text: "Amministratori"
        })
      ]),
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moderators()))
      }, [
        _hoisted_8,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_moderatori",
          text: "Moderatori"
        })
      ]),
      _createVNode("div", {
        class: "listButton genericShadow",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeCommunity()))
      }, [
        _hoisted_9,
        _createVNode(_component_localized_text, {
          class: "fs_14 spaceCadet ms-3",
          localizedKey: "app_elimina{{type}}",
          text: "Elimina {{type}}",
          object: { 'type': _ctx.type }
        }, null, 8, ["object"])
      ])
    ])
  ]))
}